import Slide from '@/mixins/Slide'

export default
{
    mixins: [
        Slide
    ],

    props:
    {
        data: { type: Object, default: false }
    }
}
